import React from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { FallbackError } from '../FallbackError';
import { supabase } from '../../supabase';

export const AuthErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const handleError = async (error: Error) => {
    // Handle authentication errors
    console.error('Auth error:', error);
    
    // Sign out user if there's an auth error
    try {
      await supabase.auth.signOut();
    } catch (err) {
      console.error('Error signing out:', err);
    }
  };

  return (
    <ErrorBoundary
      name="Authentication"
      onError={handleError}
      fallback={
        <FallbackError
          componentName="Authentication"
          error={new Error("Authentication error. Please try signing in again.")}
          resetError={() => window.location.reload()}
        />
      }
    >
      {children}
    </ErrorBoundary>
  );
};
